import React from 'react'
import styled from 'styled-components'

export default function IntegrationTagField(props: {
  children: React.ReactNode
}) {
  const {children} = props

  return <Box>{children}</Box>
}

const Box = styled.div`
  display: flex;
  gap: ${(props) => props.theme.spacing[1]};

  > div {
    flex: 1;
  }
`
